// AI Generated Test
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { PageFixRepoService } from '@client/app/services/api/pagefix-repo/page-fix-repo.service';
import { PAGE_FIX_FIXABLE_TYPES } from '../../constants/page-fix-fixable-types';

@Component({
    selector: 'page-fix-summary',
    standalone: false,
    template: `
        <page-header [icon]="['MENUES', 'PAGE_FIX'] | monIcons" [header]="'PageCorrect Summary' | translate"></page-header>

        <mon-spinner [loading]="loading">
            <div class="row align-items-stretch">
                <div class="col-48 col-md-24">
                    <div class="card panel-monsido-card">
                        <div class="card-header px-4 py-4">
                            <h2 class="card-title font-weight-300 mt-0" translate>PageCorrects categorized</h2>
                        </div>
                        <div class="card-body" *ngIf="!loading">
                            <p class="text-center" translate>Distribution of PageCorrects across all change types</p>
                            <div class="px-12">
                                <page-fix-summary-change-types
                                    [links]="linkFixes"
                                    [spellingFixes]="spellingFixes"
                                    [accessibilityChecks]="accessibilityCheckFixes"
                                    [accessibilitySourceCodes]="accessibilitySourceCodeFixes"
                                    [customFixes]="customFixes">
                                </page-fix-summary-change-types>
                            </div>
                        </div>
                    </div>
                    <div class="card panel-monsido-card">
                        <mon-panel-header [pHeader]="'Latest Updated PageCorrects' | translate">
                        </mon-panel-header>
                        <div class="card-body" *ngIf="!loading">
                            <page-fix-summary-table [pageFixes]="latestPageFixes">
                            </page-fix-summary-table>
                        </div>
                        <div class="card-footer bg-white text-right">
                            <a uiSref="base.customer.domain.page-fix.index" translate>
                                SHOW LIST VIEW
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-48 col-md-24">
                    <div class="card panel-monsido-card">
                        <mon-panel-header [pHeader]="'PageCorrect Diagnostics' | translate">
                        </mon-panel-header>
                        <div class="card-body py-7 px-8" *ngIf="!loading">
                            <page-fix-summary-diagnostics [totalPageFixes]="totalFixes" [spellingFixes]="spellingFixes">
                            </page-fix-summary-diagnostics>
                        </div>
                    </div>
                </div>
            </div>
        </mon-spinner>
    `,
})
export class PageFixSummaryComponent implements OnInit {
    totalFixes = 0;
    spellingFixes = 0;
    linkFixes = 0;
    accessibilitySourceCodeFixes = 0;
    accessibilityCheckFixes = 0;
    customFixes = 0;
    loading = true;
    latestPageFixes: any = [];

    constructor (
        private pageFixRepoService: PageFixRepoService,
        private stateService: StateService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.totalFixes = 0;
        this.spellingFixes = 0;
        this.linkFixes = 0;
        this.accessibilitySourceCodeFixes = 0;
        this.accessibilityCheckFixes = 0;
        this.loading = true;

        Promise.all([
            this.getPageFixes(PAGE_FIX_FIXABLE_TYPES.misspelling),
            this.getPageFixes(PAGE_FIX_FIXABLE_TYPES.link),
            this.getPageFixes(PAGE_FIX_FIXABLE_TYPES.accessibility_source_code),
            this.getPageFixes(PAGE_FIX_FIXABLE_TYPES.accessibility_check),
            this.getPageFixes(PAGE_FIX_FIXABLE_TYPES.custom, 1, undefined, undefined),
            this.getPageFixes(undefined, 3, 'updated_at', 'desc'),
        ])
            .then((values: any[]) => {
                this.spellingFixes = parseInt(values[0].total, 10);
                this.linkFixes = parseInt(values[1].total, 10);
                this.accessibilitySourceCodeFixes = parseInt(values[2].total, 10);
                this.accessibilityCheckFixes = parseInt(values[3].total, 10);
                this.customFixes = parseInt(values[4].total, 10);
                this.latestPageFixes = values[5];
                this.totalFixes =
                    this.spellingFixes +
                    this.linkFixes +
                    this.accessibilityCheckFixes +
                    this.accessibilitySourceCodeFixes +
                    this.customFixes;
            })
            .catch(() => {
                // Handle error silently as in original
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private getPageFixes (type: any, pageSize?: number, sortBy?: string, sortDir?: string): Promise<any> {
        const params: any = {
            page: 1,
            page_size: pageSize || 1,
            fixable_type: type,
            sort_by: sortBy,
            sort_dir: sortDir,
        };

        return this.pageFixRepoService.getAll(params).then(
            (data: any) => {
                return data;
            },
            () => {
                const res: any = [];
                res.total = 0;
                return res;
            },
        );
    }
}
